// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../_css-loader@0.28.11@css-loader/index.js!./index.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../_vue-style-loader@3.1.2@vue-style-loader/lib/addStylesClient.js")("8ea7ffcc", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_mavon-editor@2.9.1@mavon-editor/dist/css/index.css
// module id = 40
// module chunks = 0